import React from 'react'
import PropTypes from 'prop-types'
import CodeForkIcon from '../ui/icons/CodeForkIcon'
import { formatNumberList } from './ConditionsDrawer/helpers'

const WRAPPER = [
  'tw:flex',
  'tw:items-center',
  'tw:gap-3',
  'tw:rounded-md!',
  'tw:bg-ds-info-lowest',
  'tw:px-4',
  'tw:py-3',
  'tw:mb-3',
  'tw:cursor-pointer'
].join(' ')

const errorLabel = numbers => {
  if (numbers.length === 0)
    return 'Condition'
  if (numbers.length === 1)
    return `Condition n°${numbers[0]}`

  return `Conditions n°${formatNumberList(numbers)}`
}

const QuestionConditionsBanner = ({ numbers, error, onClick }) => {
  if (numbers.length === 0)
    return null

  const count = numbers.length
  let sentence = '1 condition est liée à cette question.'
  let detail = `Condition n°${formatNumberList(numbers)}`
  if (count > 1) {
    sentence = `${count} conditions sont liées à cette question.`
    detail = `Conditions n°${formatNumberList(numbers)}`
  }

  return (
    <>
      <div className={WRAPPER} role="button" tabIndex={0} onClick={onClick}>
        <CodeForkIcon className="tw:text-ds-info-pressed tw:shrink-0" />
        <div className="tw:flex-1 tw:text-sm tw:text-ds-info-pressed tw:leading-tight">
          <div className="tw:font-semibold">{sentence}</div>
          <div>{detail}</div>
        </div>
        <span className="tw:flex tw:items-center tw:gap-1 tw:text-sm tw:font-medium tw:text-ds-info-pressed">
          Voir
          {' '}
          <i className="fas fa-arrow-right" />
        </span>
      </div>
      {error ? (
        <div className="tw:-mt-2 tw:mb-3" data-condition-error>
          <small className="text-danger">
            {`${errorLabel(error.numbers)} : ${error.messages.join(' ')}`}
          </small>
        </div>
      ) : null}
    </>
  )
}

QuestionConditionsBanner.propTypes = {
  error: PropTypes.shape({
    messages: PropTypes.arrayOf(PropTypes.string).isRequired,
    numbers: PropTypes.arrayOf(PropTypes.number).isRequired
  }),
  numbers: PropTypes.arrayOf(PropTypes.number).isRequired,
  onClick: PropTypes.func.isRequired
}

QuestionConditionsBanner.defaultProps = {
  error: null
}

export default QuestionConditionsBanner
